import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name"];
import { Route } from 'react-router-dom';
import { useNamedRoute } from '../../../hooks/routeStateHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const NamedRoute = _ref => {
  let {
      name
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  useNamedRoute({
    name,
    path: props.path
  });
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default NamedRoute;